import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import { i18n } from '../../../../../helpers/i18n';
import { useActions } from '../../../../../hooks';
import { toggleCheckDesktopAppExistenceSettings as toggleCheckDesktopAppExistenceSettingsAction } from '../../../../settings';
import { SettingsTumbler } from './settings-tumbler';

export const DoNotCheckDesktopAppExistenceTumbler: FunctionComponent = () => {
    const { toggleCheckDesktopAppExistenceSettings } = useActions({
        toggleCheckDesktopAppExistenceSettings: toggleCheckDesktopAppExistenceSettingsAction,
    });

    const checkDesktopAppExistence = useSelector((state) => state.settings.checkDesktopAppExistence);

    const onChange = () => toggleCheckDesktopAppExistenceSettings();

    return (
        <SettingsTumbler
            label={i18n('settings-v2', 'develop-do-not-check-desktop-app-existence')}
            checked={checkDesktopAppExistence}
            onChange={onChange}
            testId="do-not-check-desktop-app-existence-tumbler"
        />
    );
};
